export default __webpack_public_path__ + "ffc.css.liquid";